import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

import candidates from "./candidates";
import client from "./client";

// Old campaign bumpstops
import campaigns from "./campaigns";

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    // Each of these routes are loaded asynchronously, when a user first
    // navigates to each corresponding endpoint. The route will load once into
    // memory, the first time it's called, and no more on future calls. This
    // behavior can be observed on the network tab of your browser dev tools.
    // component: () => import(/* webpackChunkName: "" */ "@/views/.vue"),
    {
      path: "/404",
      component: () =>
        import(/* webpackChunkName: "not-found" */ "@/views/NotFound.vue")
    },
    {
      path: "/login",
      component: () =>
        import(/* webpackChunkName: "login" */ "@/views/Login.vue")
    },
    {
      path: "/password_reset",
      component: () =>
        import(
          /* webpackChunkName: "password-reset" */ "@/views/PasswordReset.vue"
        )
    },
    {
      path: "/:role/confirm_email/:token",
      component: () =>
        import(
          /* webpackChunkName: "confirm-email" */ "@/views/ConfirmEmail.vue"
        )
    },
    {
      path: "/:role/password_reset/:token",
      component: () =>
        import(
          /* webpackChunkName: "password-reset" */ "@/views/PasswordReset.vue"
        )
    },
    {
      path: "/dashboard",
      meta: { auth: true },
      component: () =>
        import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard.vue")
    },
    {
      path: "/organizations/:id",
      component: () =>
        import(
          /* webpackChunkName: "guest-organization" */ "@/views/guest/Organization.vue"
        )
    },
    {
      path: "/organizations/:id(\\d+)/:name",
      component: () =>
        import(
          /* webpackChunkName: "guest-organization" */ "@/views/guest/Organization.vue"
        )
    },
    {
      path: "/opportunities",
      component: () =>
        import(
          /* webpackChunkName: "opportunities" */ "@/views/Opportunities.vue"
        )
    },
    {
      path: "/opportunities/:id",
      component: () =>
        import(
          /* webpackChunkName: "guest-opportunity" */ "@/views/guest/Opportunity.vue"
        )
    },
    {
      path: "/opportunities/:id/:name",
      component: () =>
        import(
          /* webpackChunkName: "guest-opportunity" */ "@/views/guest/Opportunity.vue"
        )
    },
    ...candidates,
    ...client,
    {
      path: "/campaign/:slug",
      component: () =>
        import(/* webpackChunkName: "campaign" */ "@/views/Campaign.vue")
    },
    ...campaigns,
    {
      path: "/",
      component: () => import(/* webpackChunkName: "home" */ "@/views/Home.vue")
    },
    {
      path: "/employers",
      component: () =>
        import(/* webpackChunkName: "employers" */ "@/views/Employers.vue")
    },
    {
      path: "/supervisor/review",
      meta: { minimal: true },
      component: () =>
        import(
          /* webpackChunkName: "supervisor-review" */ "@/views/SupervisorReview.vue"
        )
    },
    {
      path: "/listings/:id",
      component: () =>
        import(/* webpackChunkName: "listing" */ "@/views/Listing.vue")
    },
    // Render everything else as a 404
    {
      path: "*",
      component: () =>
        import(/* webpackChunkName: "not-found" */ "@/views/NotFound.vue")
    }
  ]
});

// Authentication Navigation Guard
// see: https://router.vuejs.org/en/advanced/navigation-guards.html
router.beforeEach((to, from, next) => {
  // Crisp Chat Toggle (hides on admin pages and shows elsewhere)
  if (window.CRISP_WEBSITE_ID) {
    $crisp.push(["do", "chat:show"]);
  }

  // Check for presence of rules
  if (to.meta && to.meta.auth != null) {
    const auth = to.meta.auth;
    // Pull role from the token since the state may not have it yet
    const payload = router.app.$auth.getPayload();
    const role = payload && payload.role;

    /* { auth: true } // Must be logged in */
    if (auth === true) {
      if (role) next();
      if (!role || role === null) next("/");
    }

    /* { auth: false } // Must not be logged in */
    if (auth === false) {
      if (role) next("/dashboard");
      if (role === null) next();
    }

    /* { auth: 'admin' } // Must be logged in as an admin */
    if (typeof auth === "string") {
      if (role === null) next("/");
      if (role != auth) next("/dashboard");
      if (role === auth) next();
    }

    /* TODO: { auth: ['admin', 'client'] } // Must be logged in as an admin or client */
  } else {
    // No rules – sshh, just let it happen
    next();
  }
});

export default router;
